import { render, staticRenderFns } from "./orderbusine.vue?vue&type=template&id=b38ab956&scoped=true&"
import script from "./orderbusine.vue?vue&type=script&lang=js&"
export * from "./orderbusine.vue?vue&type=script&lang=js&"
import style0 from "./orderbusine.vue?vue&type=style&index=0&id=b38ab956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38ab956",
  null
  
)

export default component.exports